var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4815 3.35567C7.73495 3.86235 6.1823 4.88152 5.02609 6.28022C3.86989 7.67891 3.16382 9.39218 3 11.1965H7.13081C7.3716 8.4508 8.17095 5.78261 9.48021 3.35438L9.4815 3.35567ZM7.13081 12.8035H3C3.16348 14.6079 3.86924 16.3214 5.02522 17.7203C6.1812 19.1192 7.73371 20.1387 9.48021 20.6456C8.17095 18.2174 7.3716 15.5492 7.13081 12.8035ZM11.5508 20.9889C9.98569 18.5168 9.02614 15.7129 8.74957 12.8035H15.2491C14.9726 15.7129 14.013 18.5168 12.4479 20.9889C12.1491 21.0037 11.8496 21.0037 11.5508 20.9889ZM14.5198 20.6444C16.2661 20.1375 17.8185 19.1182 18.9744 17.7195C20.1304 16.3208 20.8363 14.6077 21 12.8035H16.8692C16.6284 15.5492 15.829 18.2174 14.5198 20.6456V20.6444ZM16.8692 11.1965H21C20.8365 9.39212 20.1308 7.67868 18.9748 6.27975C17.8188 4.88083 16.2663 3.86137 14.5198 3.35438C15.829 5.78261 16.6284 8.4508 16.8692 11.1965ZM11.5508 3.01113C11.8501 2.99629 12.1499 2.99629 12.4492 3.01113C14.0139 5.48331 14.973 8.28721 15.2491 11.1965H8.75086C9.03098 8.26922 9.99269 5.46276 11.5508 3.01113Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.55cd6c1554a6f09482e35d8d1cc544c0.svg";
export { ForwardRef as ReactComponent };